import AccessibilityPage from './AccessibilityPage';

export default AccessibilityPage;
